import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useFirebaseDataContext } from "../context/FirebaseContextProvider";
import Cardcmp from "./Card";
import { auth } from "../config/Firebase";
import AlertDisplay from "../../../../componenets/AlertDisplay";

const ReadTopics = () => {
  const {
    name,
    topics,
    logout,
    incrementVoteCount,
    showAlert,
    alertText,
    alertType,
    setShowAlert,
  } = useFirebaseDataContext();

  return (
    <>
      {showAlert && alertType && alertText && (
        <AlertDisplay
          alertType={alertType}
          alertText={alertText}
          setShowAlert={setShowAlert}
        />
      )}

      {
        <Container>
          <div
            className="div d-flex m-auto mb-2"
            style={{ justifyContent: "space-between" }}
          ></div>
          <Row>
            {topics?.map((currdata) => {
              return (
                <Cardcmp
                  key={currdata?.id}
                  incrementVoteCount={() =>
                    incrementVoteCount(currdata?.id, currdata?.topicTitle)
                  }
                  {...currdata}
                />
              );
            })}
          </Row>
        </Container>
      }
    </>
  );
};

export default ReadTopics;
